import { API_ENDPOINTS } from 'App/constants'

import { defaultBpIdForConfigs } from '../../constants'

export const quizLandingPageConfigPath = `${API_ENDPOINTS.DCDUrl}/${defaultBpIdForConfigs}/ds-quiz-landing-page-config`
